<script setup lang="ts">
import { computed, defineAsyncComponent, withDefaults } from 'vue'

interface PropTypes {
  title: string
  layout?: string
}

const props = withDefaults(defineProps<PropTypes>(), {
  layout: 'TitledPageLayout',
})
const layout = computed(() => defineAsyncComponent(() => import(`Common/components/layouts/${props.layout}.vue`)))
</script>

<template>
  <component :is="layout">
    <template #title>
      <h1 class="text-4xl font-medium">{{ props.title }}</h1>
    </template>
    <template #main-content>
      <slot name="main-content" />
    </template>
  </component>
</template>
